import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_PROVIDERS_IM } from 'constants/url';
import { iProviders } from 'interfaces/imProviders.interface';

export default function useProvidersIM() {
  const { jwt } = useUser();
  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getProvidersActive = (): Promise<iProviders[]> => {
    return axios.get(`${URL_PROVIDERS_IM}/active`, { headers }).then((result: AxiosResponse) => {
      return result.data;
    });
  };
  const getProvidersAll = (): Promise<iProviders[]> => {
    return axios.get(`${URL_PROVIDERS_IM}`, { headers }).then((result: AxiosResponse) => {
      return result.data;
    });
  };

  const getProviderById = (wareHouseId: string): Promise<iProviders> => {
    return axios.get(`${URL_PROVIDERS_IM}/${wareHouseId}`, { headers }).then((result: AxiosResponse) => {
      if (result.status === 200) {
        return result.data;
      } else {
        return null;
      }
    });
  };

  const addProvider = (data: any): Promise<boolean> => {
    return axios.post(URL_PROVIDERS_IM, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 201;
    });
  };

  const updateProvider = (data: any): Promise<boolean> => {
    if (!data.id) throw new Error('El campo id es obligatorio');
    return axios.put(`${URL_PROVIDERS_IM}/${data.id}`, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 200;
    });
  };

  return {
    getProvidersAll,
    getProvidersActive,
    getProviderById,
    addProvider,
    updateProvider
  };
}
